<div class="track" [style.height.px]="height()">
  <div class="fill" [style.width.%]="clampedValue()" [style.background]="color()"></div>
</div>
